import { render, staticRenderFns } from "./Community.vue?vue&type=template&id=099567c6&scoped=true&"
import script from "./Community.vue?vue&type=script&lang=js&"
export * from "./Community.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099567c6",
  null
  
)

export default component.exports